import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-real-time',
	templateUrl:'./RealTimePage.html',
	styles: [],
	styleUrls:['./RealTimePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		WaTagDirective,
],
	standalone:true
})
export class RealTimePage
{
}
